import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MessageUI from "../components/CandidateChat/MessageUI";
import ChatUI from "../components/CandidateChat/ChatUI";
import Login from "../components/Login";
import Register from "../components/Register";
import Home from "../components/Home";
import { AuthProvider } from "../Hooks/auth/AuthProvider";
import PersistLogin from '../Hooks/Token/PersistLogin'
import ProtectedRoutes from './ProtectedRoutes'
import Contact from "../components/Contact";
import HowItWorks from "../components/howitworks";
import Services from "../components/Services";
import PrivacyPolicy from "../components/Privacy";
import TermsOfService from "../components/Terms";
import RefundPolicy from "../components/Refund";
import Order from "../components/Order";

export default function Routing() {
    return (<>
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="home" element={<Home />} />
                    <Route path="services" element={<Services />} />
                    <Route path="order" element={<Order />} />
                    <Route path="how" element={<HowItWorks />} />
                    <Route path="contact" element={<Contact />} />
                    <Route path="terms" element={<TermsOfService />} />
                    <Route path="privacy" element={<PrivacyPolicy />} />
                    <Route path="refund" element={<RefundPolicy />} />
                    <Route path="login" element={<Login />} />
                    <Route path="register" element={<Register />} />
                    <Route element={<PersistLogin />}>
                        <Route element={<ProtectedRoutes />}>
                            <Route path='message' element={<MessageUI />} />
                            <Route path='chat/:userId' element={<ChatUI />} />
                        </Route>
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    </>
    )
}